"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isActive = exports.comesFromAdap = exports.canRenovate = exports.willBeAnulled = exports.needsExtraDay = exports.ANNULMENT_STATUS = exports.ACTIVE_STATUS = exports.ADAP_STATUS = exports.Status = void 0;
var date_fns_1 = require("date-fns");
var dateFormats_1 = require("../helpers/dateFormats/dateFormats");
/**
 * These are the status codes that can be identified as "active" in at least one
 * scenario.
 */
var Status;
(function (Status) {
    Status["ACT"] = "ACT";
    Status["REN"] = "REN";
    Status["MOD"] = "MOD";
    Status["VAL"] = "VAL";
    Status["COM"] = "COMPLETED";
    Status["ANU"] = "ANU";
    Status["APD"] = "APD";
})(Status = exports.Status || (exports.Status = {}));
/**
 * This status corresponds to policies comming from the adap service instead of
 * the regular response from acsel.
 */
exports.ADAP_STATUS = 'ADAP';
/**
 * As of 2/24/2021 these two arrays are equal but we keep them separated
 * to accomodate future business logic changes
 */
exports.ACTIVE_STATUS = [
    Status.ACT,
    Status.MOD,
    Status.REN,
    Status.VAL,
    Status.COM,
];
exports.ANNULMENT_STATUS = [Status.ANU, Status.APD];
/**
 * Returns true if status is ACT and provided endDate is still within targetDate.
 * ? This function may need refactor if it includes other statuses, for now is only ACT.
 *
 * @param policy - The policy to check
 * @param targetDate - The date to use as a baseline
 * @param endDate - The policy end date
 */
function needsExtraDay(policy, endDate) {
    /**
     * We have to add +1 day to the endDate, because the activation is inclusive.
     * so if it returns 11/01/21 00:00:00, it is still active until 11:59:59.
     *  */
    if (policy.policyStatus === Status.ACT ||
        policy.policyStatus === Status.REN) {
        endDate.setDate(endDate.getDate() + 1);
        endDate.setHours(0, 0, 0, 0);
        return new Date(endDate);
    }
    return endDate;
}
exports.needsExtraDay = needsExtraDay;
/**
 * Returns true if the provided policy will be active in a future date (basically, pending activation).
 *
 * @param policy - The policy to check
 * @param targetDate - The date to use as a baseline
 * @param startDate - The polucy start date, as a Date instance
 */
function willBeAnulled(policy) {
    if (!policy) {
        return false;
    }
    var startDate = dateFormats_1.dateFromString(policy.effectiveStartDate);
    var targetDate = new Date();
    var twoMonthsFromNow = date_fns_1.addDays(new Date(), 60);
    if (!date_fns_1.isValid(startDate)) {
        return false;
    }
    return ((date_fns_1.isWithinInterval(startDate, {
        start: targetDate,
        end: twoMonthsFromNow,
    }) ||
        date_fns_1.isAfter(new Date(), startDate)) &&
        exports.ANNULMENT_STATUS.includes(policy.policyStatus));
}
exports.willBeAnulled = willBeAnulled;
/**
 * Checks if a policy is within 60 days from today, if so, it is permitted to
 * emit with initial date of policy's effectiveEndDate + 1
 * @param policy - CarPolicy to check
 * @param endDate - effective end date of the policy
 * @returns
 */
function canRenovate(policy) {
    if (!policy) {
        return false;
    }
    var endDate = dateFormats_1.dateFromString(policy.effectiveEndDate);
    if (!date_fns_1.isValid(endDate)) {
        return false;
    }
    return (date_fns_1.isWithinInterval(needsExtraDay(policy, endDate), {
        start: new Date(),
        end: dateFormats_1.addDayToDate(new Date(), 60),
    }) && exports.ACTIVE_STATUS.includes(policy.policyStatus));
}
exports.canRenovate = canRenovate;
/**
 * Returns true if the provided policy is considered active (includes: target date between start and end date)
 *
 * @param policy - The policy to check
 * @param targetDate - The date to use as a baseline
 * @param startDate - The policy start date, as a Date instance
 * @param endDate - The policy end date, as a Date instance
 */
function isCurrentlyActive(policy, targetDate, startDate, endDate) {
    return ((date_fns_1.isAfter(startDate, targetDate) ||
        date_fns_1.isAfter(needsExtraDay(policy, endDate), dateFormats_1.addDayToDate(targetDate, 60))) &&
        !canRenovate(policy) &&
        !willBeAnulled(policy));
}
/**
 * Will return true if the proided policy comes from ADAP
 *
 * @param policy - The policy to check
 */
function comesFromAdap(policy) {
    return typeof policy !== 'undefined' && policy.policyStatus === exports.ADAP_STATUS;
}
exports.comesFromAdap = comesFromAdap;
/**
 * Returns true if the provided policy is considered active
 *
 * @param policy - The policy to check
 * @param targetDate - the date used to check if it is active
 */
function isActive(policy, targetDate) {
    if (targetDate === void 0) { targetDate = new Date(); }
    if (!policy) {
        return false;
    }
    var startDate = dateFormats_1.dateFromString(policy.effectiveStartDate);
    var endDate = dateFormats_1.dateFromString(policy.effectiveEndDate);
    if (!date_fns_1.isValid(startDate) || !date_fns_1.isValid(endDate) || comesFromAdap(policy)) {
        return false;
    }
    return isCurrentlyActive(policy, targetDate, startDate, endDate);
}
exports.isActive = isActive;
//# sourceMappingURL=carPolicyMethods.js.map